import { motion } from "framer-motion"

const avatarStack = [
  "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=100",
  "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=100",
]

function FinalCTABonus() {
  return (
    <section id="cta-final" className="relative bg-white py-16 sm:py-24 px-4 overflow-hidden">
      {/* Decorative flags */}
      <div className="absolute top-10 left-5 text-6xl opacity-5 select-none" aria-hidden="true">🇺🇸</div>
      <div className="absolute bottom-10 right-5 text-6xl opacity-10 select-none" aria-hidden="true">🇬🇧</div>

      <div className="max-w-3xl mx-auto text-center relative z-10">
        {/* Vale Bônus Logo */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex justify-center mb-6"
        >
          <img
            src="https://static.lumi.new/material/8b/8b4ea0eff349aaddfccb24568ad43a28.png"
            alt="Vale Bônus"
            className="h-8 sm:h-12"
          />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3"
        >
          Daqui a 6 meses você pode estar no mesmo lugar.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-xl sm:text-2xl font-bold text-blue-600 mb-2"
        >
          Ou pode estar em outro nível.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="text-red-600 font-extrabold text-2xl mb-6"
        >
          A decisão é sua.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-gray-600 space-y-1 mb-8"
        >
          <p>Você já sabe o que funciona.</p>
          <p>Agora só precisa começar.</p>
        </motion.div>

        {/* Pricing - Bonus */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="bg-gradient-to-br from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-2xl p-8 mb-8"
        >
          <p className="text-gray-500 line-through text-lg mb-1">R$ 299,40</p>
          <p className="text-4xl sm:text-5xl font-black text-blue-900 mb-2">R$ 175,00</p>
          <p className="text-green-600 font-bold text-lg">🎉 Economize R$ 124,40 | Exclusivo Vale Bônus</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mb-8"
        >
          <a
            href="https://checkout.ewpass.com.br/subscribe/ewpass-pro?&coupon=ewcompropay"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 text-white font-extrabold text-lg sm:text-xl px-10 py-5 rounded-xl hover:bg-blue-700 transition-colors animate-pulse-glow-blue"
          >
            👉 Garantir meu acesso com segurança total
          </a>
        </motion.div>

        {/* Social proof */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <div className="flex -space-x-2">
            {avatarStack.map((url, i) => (
              <img
                key={i}
                src={url}
                alt="Aluno"
                className="w-8 h-8 rounded-full border-2 border-white object-cover"
              />
            ))}
            <div className="w-8 h-8 rounded-full bg-blue-600 border-2 border-white flex items-center justify-center text-white text-xs font-bold">
              10k+
            </div>
          </div>
          <p className="text-gray-600 font-medium">
            Junte-se a 10.000+ alunos que já saíram do básico
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default FinalCTABonus
